// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/bolt-slash.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/bolt-slash'

import { Icon, type IconComponentProps } from '../icon'

export const BoltSlashIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
